import React, { useEffect, useState } from "react";
import { GoogleMap, Marker, InfoWindow, Polygon } from "@react-google-maps/api";
import locationIcon from "../../assets/images/logo/location.png";
import { toast } from "react-toastify";
  
const containerStyle = {
  width: "100%",
  height: "100vh",
};

const TrackingMapGoogle = ({ setLocations, locations, area }) => {
  const [center, setCenter] = useState({ lat: 31.0465, lng: 31.3725 });
  const [markerPosition, setMarkerPosition] = useState(null);
  const [selectedPoint, setSelectedPoint] = useState(null);
  const polygonPath =
    Array.isArray(area) && area.length > 2
      ? area.map((loc) => ({
          lat: Number(loc.lat),
          lng: Number(loc.long),
        }))
      : [];
  console.log("polygonPath", polygonPath);
  useEffect(() => {
    if (locations?.lat && locations?.long) {
      const lat = Number(locations.lat);
      const lng = Number(locations.long);

      setSelectedPoint(locations);
      setMarkerPosition({ lat, lng });
      setCenter({ lat, lng });
    } else {
      setSelectedPoint(null);
      setMarkerPosition(null);
    }
  }, [locations]);

  useEffect(()=>{

    if(area?.length>0 && area){
setCenter(area[0])
    }
  },[area])
  const handleMapClick = (e) => {
    const lat = e.latLng.lat();
    const lng = e.latLng.lng();

    const clickedPoint = new window.google.maps.LatLng(
      e.latLng.lat(),
      e.latLng.lng(),
    );
    console.log("clickedPoint", clickedPoint);
    const polygon = new window.google.maps.Polygon({
      path: polygonPath,
    });
    console.log("polygon", polygon);
    const isOnLine = window.google.maps.geometry.poly.containsLocation(
      new window.google.maps.LatLng(lat, lng),
      polygon,
    );
    if (!isOnLine) {
      toast.error("يجب اختيار موقع المتجر داخل المنطقة المحددة");
      return;
    }
    const newPoint = { lat, long: lng, location: `Lat: ${lat}, Long: ${lng}` };

    setMarkerPosition({ lat, lng });
    setSelectedPoint(newPoint);
    setLocations(newPoint);
    setCenter({ lat, lng });
  };

  return (
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={center}
      zoom={14}
      onClick={handleMapClick}
    >
      {/* Marker */}
      {markerPosition && (
        <Marker
          position={markerPosition}
          icon={{
            url: locationIcon,
            scaledSize: new window.google.maps.Size(40, 40),
             anchor: new window.google.maps.Point(20, 40),
          }}
          onClick={() => setSelectedPoint(markerPosition)}
        />
      )}
      {polygonPath.length > 2 && (
        <Polygon
          paths={polygonPath}
          options={{
            fillColor: "#FFCC03",
            fillOpacity: 0.35,
            strokeColor: "#FFCC03",
            strokeOpacity: 0.8,
            strokeWeight: 2,
            clickable: false,
            editable: false,
            zIndex: 1,
          }}
        />
      )}
      {/* InfoWindow */}
      {selectedPoint && (
        <InfoWindow
          position={{
            lat: parseFloat(selectedPoint.lat),
            lng: parseFloat(selectedPoint.long),
          }}
          onCloseClick={() => setSelectedPoint(null)}
        >
          <div>
            <strong>Location:</strong>
            <br />
            Lat: {selectedPoint.lat}, Long: {selectedPoint.long}
          </div>
        </InfoWindow>
      )}
    </GoogleMap>
  );
};

export default TrackingMapGoogle;
